// extracted by mini-css-extract-plugin
export var buttonLinkContainer = "Legal_buttonLinkContainer__y7hvb";
export var legalContainer = "Legal_legalContainer__3Ikh7";
export var seeDetails = "Legal_seeDetails__a+qiH";
export var supContainer = "Legal_supContainer__m+WhH";